import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
import config from '@/config/base-config'
import { getToken,dealAuthRoute} from "@/lib/util";
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history'
})

const LOGIN_PAGE_NAME = config.LOGIN_PAGE
const HOME_PAGE_NAME = config.HOME_PAGE

router.beforeEach((to, from, next) => {
  // 刷新页面需要重新添加路由
  if (!store.state.app.isAddRoute){
    // 仅已登录时添加动态路由：未登录时不添加，避免未登录时先把 404 通配符路由
    // 添加进路由表，导致登录后真实路由排在其后而被通配符拦截，出现 404 页面
    if (getToken()) {
      // 立即同步添加动态路由，保证首次点击菜单能命中路由
      try {
        dealAuthRoute(undefined, { routerInstance: router, storeInstance: store })
      } catch (err) {
        console.error('dealAuthRoute error:', err)
      }
      // 重新发起本次导航，replace 避免记录错误历史
      return next({ ...to, replace: true })
    }
  }
  let token = getToken()
  if (!token && to.name !== LOGIN_PAGE_NAME){
    next( { name: LOGIN_PAGE_NAME})
  }else if (!token && to.name === LOGIN_PAGE_NAME){
    next()
  }else if (token && to.name === LOGIN_PAGE_NAME){
    // 根据用户组ID跳转到不同的首页
    const groupID = parseInt(sessionStorage.getItem('groupID')) || 0;
    const defaultHomeName = groupID === 3 ? '工作台' : HOME_PAGE_NAME;
    next({name: defaultHomeName})
  }else {
    next()
  }

})

export default router